import React from 'react';
import {observer} from 'mobx-react';
import { observable, action, makeObservable } from 'mobx';
import {Label} from 'shared/components';
import LineClamp from 'shared/components/LineClamp';

class TextAreaView extends React.Component {
  expanded = false;

  constructor(props) {
    super(props);

    makeObservable(this, {
      expanded: observable,
      toggleAnswer: action
    });
  }

  toggleAnswer() {
    const {answer} = this.props;

    if (answer.content) {
      this.expanded = !this.expanded;
    }
  }

  render() {
    const {answer} = this.props;

    return (
      <div>
        <div className='medium h3'>{answer.question.name}</div>
        {!this.expanded &&
          <div className={answer.content && 'clickable'} onClick={() => this.toggleAnswer()}>
            <LineClamp lines={2}>
              <Label model={answer.content}/>
            </LineClamp>
          </div>}
        {this.expanded && <div onClick={() => this.toggleAnswer()} className='clickable whitespace-pre-line'>{answer.content}</div>}
      </div>
    );
  }
}

export default observer(TextAreaView);
